module.exports = __webpack_public_path__ + "static/img/oprCt_bg_01.2e1c36a9.svg";